import * as RTK from '@reduxjs/toolkit';
import { Product } from '../data/product';

export type Bundle = {
    canonicalId: string;
    productIds: Array<string>;
    price: number;
    ranges: Array<string>;
    discontinued: boolean;
};

export type State = {
    // products and bundle products
    products: Array<Product> | null;

    // specifically bundle products
    bundles: Array<Bundle> | null;
};

const initialState: State = { products: null, bundles: null };

export const slice = RTK.createSlice({
    name: 'product-data',
    initialState,
    reducers: {
        setProductData(_state, action: RTK.PayloadAction<State>) {
            return action.payload;
        },
    },
});

export const { setProductData } = slice.actions;

export const reducer = slice.reducer;
